import gql from 'graphql-tag';

export const updateAdmin = gql`
  mutation updateAdmin($input: updateAdminInput!){
    updateAdmin(input: $input){
      id
    }
  }
`;

export const resetAdminPassword = gql`
  mutation resetAdminPassword($id: Int!, $temporaryPassword: String!){
    resetAdminPassword(id: $id, temporaryPassword: $temporaryPassword){
      id
      mustChangePassword
    }
  }
`;
